export enum OpportunityPriceListDocumentStatusOption {
  WAITING = '44c29795-b822-448e-a790-088d8b47b2e2',
  APPROVED = 'be45b8cc-226e-44b1-a1e8-178bed29f2a8',
  DENIED = '63f941d0-892a-40a7-b5cf-7c1ccdc6f21f'
}
